import { useEffect, useState } from 'react';

interface WindowDimension {
  viewportWidth: number;
  viewportHeight: number;
}

const getWindowDimensions = (): WindowDimension => {
  const { innerWidth: viewportWidth, innerHeight: viewportHeight } = window;
  return {
    viewportWidth,
    viewportHeight,
  };
};

export const useWindowDimensions = (): WindowDimension => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};
